import React, { useEffect, useState } from "react";
import { getDriverDocumentTypes, uploadDocs } from "../apis";
import "jquery-validation";
import $ from "jquery";
import StepButtons from "../components/StepButtons";
import GoToReviewPageButton from "../components/GoToReviewPageButton";
// import { upload } from "@testing-library/user-event/dist/upload";
import ModalApp from "../components/Modal/ModalApp";
import UploadDocPanel from "../panels/UploadDocPanel";
import { PDFDocument, PDFCompressor } from "pdf-lib";


const UploadDoc = ({
list,
setList, 
backPage,
nextPage,
credentials,
isDone,
lastPage,
uploadedDocData,handleRerender,
// uploadStep,
// setUploadStep,
pageNo
}) => {
///

// Use credentials values or fallback to local storage
const duid = credentials.duid || localStorage.getItem('duid');
const parentId = credentials.parent_id || localStorage.getItem('parent_id');

// Create a new object with the updated credentials
const updatedCredentials = {
duid: duid,
parent_id: parentId,
};
//console.log(pageNo);
const [file, setFile] = useState(null);
const [docType, setDocType] = useState([]);
const [uploadedDocs, setUploadedDocs] = useState({});
const [docId, setDocId] = useState(0);
const [showNext, setShowNext] = useState(false);
// const [showCheck, setShowCheck] = useState(1);
const [checkAccepted, setCheckAccepted] = useState(false);
const [adding, setAdding] = useState(false);
const [editing, setEditing] = useState(false);
const [editIndex, setEditIndex] = useState(null);
const [allDocsUploaded, setAllDocsUploaded] = useState(false);
const [pdf, setpdf] = useState({});



const getDocTypes = async () => {
setCheckAccepted(false);
if (adding) setAdding(false);
if (editing) setEditing(false);
if (editIndex !== null) setEditIndex(null);
// const apiRes = await getDriverDocumentTypes(uploadStep);
//console.log(list.length);
const apiRes = await getDriverDocumentTypes(list.length, pageNo);
if (apiRes.data == null) {
// setUploadStep(0);
// nextPage();

if (pageNo === 17) {
//editDoc(0,list);		
if (!list[0].files || Object.keys(list[0].files).length === 0) {
setAllDocsUploaded(false);
}
setEditing(true);
setEditIndex(0);
setUploadedDocs(list[0].files);
setDocType(list[0].docType);
setDocId(list[0].docType.id);
setShowNext(true);
setCheckAccepted(!list[0].files || Object.keys(list[0].files).length === 0);
} else {
setAllDocsUploaded(true);
setDocType([]);
setDocId(0);
setUploadedDocs({});
}


} else {
setDocType(apiRes.data);
setDocId(apiRes.data.id);

// setUploadStep(apiRes.data.id);
setAdding(true);
setUploadedDocs({});
}


};

useEffect(() => {
getDocTypes();
// eslint-disable-next-line
}, [list]);
// below code for only debugging.
useEffect(() => {
//console.log(Object.keys(uploadedDocs).length);
if (Object.keys(uploadedDocs).length === 1) {
setShowNext(true);
} else if (Object.keys(uploadedDocs).length === 0) {
if (pageNo != 17 && !checkAccepted) {
setShowNext(false);
}
}
}, [uploadedDocs]);

// when pdf is there 
const saveDoc = async (formData) => {
// console.log("calling1");
// console.log(formData);
if (!adding && !editing) return false;
let reqData = {};
const form = $("#data-form");
form.validate();
let final_data = [];
if (Object.keys(uploadedDocs).length === 0) {
reqData = { ...updatedCredentials, np: 1, docType: JSON.stringify(docType) };
final_data = [reqData];
} else if (form.valid()) {
reqData = { ...updatedCredentials, docType: JSON.stringify(docType) };
final_data = [reqData, ...formData];
} else return false;
// console.log(final_data);
const result = await uploadDocs("/uploadDriverDocuments", final_data);
// console.log(result);
if (result.status) {
if (editing) {
const tempList = [...list];
tempList[editIndex] = { files: uploadedDocs, docType: docType };
setList(tempList);
} else {
setList([...list, { files: uploadedDocs, docType: docType }]);
}
setCheckAccepted(false);
if (pageNo === 17) {
nextPage();
}
}saveDocToLocal()
};

// when there is no pdf
const saveDoc2 = async () => {
// console.log("calling2");
if (!adding && !editing) return false;
let reqData = {};
const form = $("#data-form");
form.validate();
if (Object.keys(uploadedDocs).length === 0) {
reqData = { ...credentials, np: 1, docType: JSON.stringify(docType) };
} else if (form.valid()) {
reqData = { ...credentials, ...uploadedDocs, docType: JSON.stringify(docType) };
} else return false;
const result = await uploadDocs("/uploadDriverDocuments", reqData);
// console.log(result);
if (result.status) {
if (editing) {
const tempList = [...list];
tempList[editIndex] = { files: uploadedDocs, docType: docType };
setList(tempList);
} else {
setList([...list, { files: uploadedDocs, docType: docType }]);
}
setCheckAccepted(false);
if (pageNo === 17) {
nextPage();
}saveDocToLocal()
}
};
///////////////////checkbox 
const handleCheckboxChange = (e) => {
setCheckAccepted(e.target.checked);
setShowNext(e.target.checked);
// Save the state to local storage when the checkbox is checked
if (e.target.checked) {
localStorage.setItem('checkAccepted', JSON.stringify(e.target.checked));
}
};
////
// Save document to local storage
const saveDocToLocal = () => {
const dataToSave = {
uploadedDocs: uploadedDocs,
docType: docType,
checkAccepted: checkAccepted,
};

// Retrieve existing data from local storage
const storedData = localStorage.getItem('uploadedDocData');
const existingData = storedData ? JSON.parse(storedData) : [];

// Check if there is existing data for the current docType.id
const indexToUpdate = existingData.findIndex(entry => entry.docType.id === docType.id);


if (indexToUpdate !== -1) {
  // Update the existing entry
  existingData[indexToUpdate] = {
    ...existingData[indexToUpdate],
    checkAccepted: checkAccepted, // Update checkAccepted based on your condition
  };
} else {
  // Add the new data to the array
  existingData.push(dataToSave);
}
// Save the updated array to local storage
localStorage.setItem('uploadedDocData', JSON.stringify(existingData));

};
/* console.log(imageKey) */
useEffect(() => {
const storedDocData = localStorage.getItem('uploadedDocData');
if (storedDocData) {
const parsedDocData = JSON.parse(storedDocData);
const lastData = parsedDocData[parsedDocData.length - 1];

setUploadedDocs(lastData.uploadedDocs || {});
setDocType(lastData.docType || []);
setCheckAccepted(lastData.checkAccepted || false);

setShowNext(Object.keys(lastData.uploadedDocs || {}).length > 0 || lastData.checkAccepted);
}

}, []);


/////////////
const goBack = () => {
// setUploadStep(0);
backPage();
};
const getFile = (e, doc_id) => {
//const file = e.target.files[0];
setFileToCrop(e.target.files[0]);
setFile(e.target.files[0]);
// console.log(fileToCrop);
setDocId(doc_id);
e.target.value = null;

// setShowCheck(false);
//setShowNext(true);
};
const deleteFile = (doc_id, i) => {
  // Check if uploadedDocs is null or undefined
  if (!uploadedDocs) {
    console.error("uploadedDocs is not properly initialized");
    return;
  }

  // Create a copy of uploadedDocs
  const updatedUploadedDocs = { ...uploadedDocs };

  // Remove the corresponding entry from local storage
  const compressedImageKey = `compressedImageURL_${doc_id}`;
  localStorage.removeItem(compressedImageKey);
setCheckAccepted(false)
  // Update the state with the modified uploadedDocs using the functional form
  setUploadedDocs((prevUploadedDocs) => {
    const newUploadedDocs = { ...prevUploadedDocs };
    delete newUploadedDocs[doc_id];
    return newUploadedDocs;
  });

  // Check if there are still files for the specified doc_id
  setShowNext(Object.keys(updatedUploadedDocs[doc_id] || {}).length > 0);
};



const [showModal, setShowModal] = useState(false);
const [fileToCrop, setFileToCrop] = useState(null);

const handleCloseModal = () => {
setShowModal(false);
setFileToCrop(null);
//setShowNext(false);
};

useEffect(() => {
if (fileToCrop !== null) {
setShowModal(true);
}
}, [fileToCrop]);



const editDoc = (index, data) => {
  // Retrieve the checkAccepted value from local storage
  const storedCheckAccepted = localStorage.getItem('checkAccepted');
  
  // Use a callback function to ensure the state is updated correctly
  setAllDocsUploaded(false);
  setEditing(true);
  setEditIndex(index);
  //setUploadedDocs(data.files);
  setDocType(data.docType);
  setDocId(data.docType.id);

  // Set checkAccepted based on the retrieved value or default to the condition on data.files
  setCheckAccepted(prevCheckAccepted => storedCheckAccepted ? JSON.parse(storedCheckAccepted) : !data.files || Object.keys(data.files).length === 0);
  
  // Set showNext based on the condition
  setShowNext(!data.files || Object.keys(data.files).length > 0 || storedCheckAccepted);
};


// sumit

const compressImage = async (file) => {
return new Promise((resolve, reject) => {
const reader = new FileReader();
reader.onload = (event) => {
const img = new Image();
img.src = event.target.result;
img.onload = () => {
const canvas = document.createElement('canvas');
const ctx = canvas.getContext('2d');
canvas.width = img.width;
canvas.height = img.height;
// Draw the image on the canvas with the original dimensions
ctx.drawImage(img, 0, 0);
// Get the compressed data URL from the canvas
/* console.log("shivamfiletype",file.type); */
let compressedDataURL;
if (file.type === 'image/jpeg') {
// For JPEG files, apply compression with quality
compressedDataURL = canvas.toDataURL('image/jpeg', 0.7); // Adjust quality here (0.7 is 70% quality)
} else if (file.type === 'image/png') {
// For PNG files
compressedDataURL = canvas.toDataURL('image/png', 0.4); // No quality parameter for PNG
} else {
// Unsupported file type
reject(new Error('Unsupported file type'));
return;
}

console.log('Compressed image:', compressedDataURL);
resolve(compressedDataURL);
};
};
reader.readAsDataURL(file);
});
};



const embedImageInPdfAndDownload = async () => {
  let compressedfile;
  let compressedImageURL;
  const pdfDoc = await PDFDocument.create();

  if (Object.keys(uploadedDocs).length === 0) {
    compressedfile = file;
    saveDoc2();
  } else {
    const uploadedFile = uploadedDocs[docId] && uploadedDocs[docId][0];
    if (uploadedFile && uploadedFile.type) {
      compressedfile = uploadedFile;
      const compressedDataURL = await compressImage(compressedfile);

      // Store compressed image URL in local storage with the document ID
      //const imageKey = `compressedImageURL_${docId}`;
      //localStorage.setItem(imageKey, compressedDataURL);

      compressedImageURL = compressedDataURL;

      const response = await fetch(compressedDataURL);
      const buffer = await response.arrayBuffer();
      let image;

      // Embed the image in the PDF document based on the file type
      if (/jpeg/i.test(compressedfile.type)) {
        image = await pdfDoc.embedJpg(buffer);
      } else if (/png/i.test(compressedfile.type)) {
        image = await pdfDoc.embedPng(buffer);
      } else {
        // Throw an error for unsupported file types
        throw new Error("Please choose a JPEG or PNG file to proceed");
      }

      // Add a page to the PDF document and draw the embedded image on it
      const page = pdfDoc.addPage();
      const width = page.getSize().width;
      const height = page.getSize().height;
      const imgWidth = image.width;
      const imgHeight = image.height;
      const scaleFactor = Math.min(width / imgWidth, height / imgHeight);
      page.drawImage(image, {
        width: imgWidth * scaleFactor,
        height: imgHeight * scaleFactor,
        x: (width - imgWidth * scaleFactor) / 2,
        y: (height - imgHeight * scaleFactor) / 2
      });

      // Save the PDF document as a base64 string
      let b64Chunk = await pdfDoc.saveAsBase64();
      // Add the necessary prefix to create a data URL
      b64Chunk = "data:application/pdf;base64," + b64Chunk;

      // Fetch the PDF blob from the data URL
      const blob = await (await fetch(b64Chunk)).blob();

      // Set the 'pdf' state with the created page
      setpdf(page);

      // Create a FormData object to send the blob to the server
      const formData = new FormData();
      formData.append('pdfFile', blob, 'imageToPdf.pdf'); // 'pdfFile' is the key for the file on the server side

      // Call the 'saveDoc' function to handle saving the document
      saveDoc(formData);

      // Return the compressed image URL
      return compressedImageURL;
    }
  }
};




const callbothfun = () => {
embedImageInPdfAndDownload(); 

// convertToPdfAndUpload();
// saveDoc();

}
const saveAndReview = () => {
  // Call the function to save the data and update local storage
  callbothfun();

  // Add any additional logic or navigation for the "Review" button click
  // For example, you might want to navigate to the review page
  // You can use the update or lastPage function provided as props
  // For illustration purposes, let's assume you have a function reviewPage() to navigate to the review page
 lastPage();
};

const isLocalStorageDataAvailable = localStorage.getItem(`compressedImageURL_${docType.id}`);

return (
<>
<ModalApp
showModal={showModal}
handleCloseModal={handleCloseModal}
file={fileToCrop}
uploadedDocs={uploadedDocs}
setUploadedDocs={setUploadedDocs}
doc_id={docId}
/>
<div className="general-content driver-info">
<div className="row d-flex">
<div className={pageNo === 17 ? ("col-md-12") : ("col-md-9")}>
<div className="driver-form-container" style={{ height: "min-content" }}>
<div className="row">
<div className="col-md-12 text-center">
<div className="dr-head clearfix">
  <div className="pull-left">Upload Driver Documents</div>
</div>
</div>
</div>
{allDocsUploaded ?
<div className="container text-center">
<p>To continue to next steps, click Next.<br />To change any of document selection, Click Edit.</p><br />
</div>
:
<>
<div className="container">
  <form id="data-form">
    <div className="container px-30">
      <div className="col-md-12">
        <div className="clearfix text-left">
          <div className="col-md-4 ach-desc">
            <b>{docType.ducument_desc}</b>
          </div>
          <div className="col-md-4 ach-desc">
            <input
              id="image"
              type="file"
              accept="image/*;capture=camera"
              onChange={(e) => {
                getFile(e, docType.id);
              }}
              disabled={checkAccepted || Object.keys(uploadedDocs).length > 0}
            />
          </div>
          <div className="col-md-4 text-right">
        {Object.keys(uploadedDocs).length === 0 && !isLocalStorageDataAvailable ? (
          <div className="doc-check">
            {" "}
            <input
              type="checkbox"
              checked={checkAccepted}
              name=""
              value={checkAccepted}
              onChange={(e) => {
                setShowNext(e.target.checked);
                setCheckAccepted(e.target.checked);
                handleCheckboxChange(e);
              }}
            />
            <span>
              Check this box if you do not provide
              <br /> <b>{docType.ducument_desc}</b>
            </span>{" "}
          </div>
        ) : (
            ""
          )}
        {/* Conditionally render the delete button based on local storage data */}
        {isLocalStorageDataAvailable && (
          <p>
            <img
              src={localStorage.getItem(`compressedImageURL_${docType.id}`)}
              width="120px" height="76px"
              alt=""
            />
            <button
              type="button"
              onClick={() => deleteFile(docType.id)}
            >
              Delete
            </button>
          </p>
        )}

          </div>
        </div>
      </div>
    </div>
  </form>
</div>
<div className="container-fluid px-30">
  <div className="row">
    <div className="col-md-12">
      <div className="dr-foot clearfix">
        {editing && pageNo != 17 &&
          <div className="pull-left" style={{ marginBottom: "20px" }}>
            <button onClick={getDocTypes} className="remove-link">
              Cancel
            </button>
          </div>
        }
      {(showNext || isLocalStorageDataAvailable) && pageNo !== 17 && (
  <div className="pull-right" style={{ marginBottom: "20px" }}>
    <button onClick={callbothfun} className="add-link">
      Save
    </button>
  </div>
)}

      </div>
      {/* <!--dr-foot--> */}
    </div>
  </div>
</div>
</>
}
{pageNo === 17 && <StepButtons goBack={goBack} goNext={callbothfun} nextAllowed={showNext} />}
{pageNo != 17 && !editing && <StepButtons goBack={goBack} goNext={nextPage} nextAllowed={allDocsUploaded} />}
</div>
</div>
<div className={pageNo === 17 ? ("col-md-3 pl-md-0 hidden") : ("col-md-3 pl-md-0")}>
<div className="licence-panel">
<div className="title">Driver Document(s)</div>
<UploadDocPanel list={list} editData={editDoc}   />
  </div>
</div>
</div>
</div>
{pageNo === 17 && <GoToReviewPageButton update={callbothfun} isDone={allDocsUploaded} />}
{pageNo != 17 && <GoToReviewPageButton update={lastPage} isDone={isDone} />}
</>
);
};

export default UploadDoc;

